var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompetitorsCase1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1714_3152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4235 84.2252C72.5861 84.2252 71.8065 84.052 71.2291 83.7921C69.179 82.7238 67.7353 81.2512 66.2916 76.9201C64.8191 72.4158 62.0472 70.308 59.3908 68.2579C57.1097 66.4966 54.7421 64.6776 52.692 60.9528C51.1617 58.1809 50.3243 55.1492 50.3243 52.4639C50.3243 44.3792 56.6766 38.0269 64.7613 38.0269C72.846 38.0269 79.1983 44.3792 79.1983 52.4639H84.973C84.973 41.1165 76.1088 32.2522 64.7613 32.2522C53.4139 32.2522 44.5496 41.1165 44.5496 52.4639C44.5496 56.102 45.6468 60.1155 47.6391 63.7247C50.2666 68.4889 53.3561 70.8855 55.8681 72.82C58.2069 74.6102 59.8816 75.9095 60.8056 78.7392C62.538 83.9942 64.7613 86.9394 68.6882 88.9894C70.1607 89.6535 71.7777 90 73.4235 90C79.8046 90 84.973 84.8316 84.973 78.4504H79.1983C79.1983 81.6266 76.5996 84.2252 73.4235 84.2252ZM46.3975 34.1001L42.2974 30C36.5515 35.7459 33 43.6862 33 52.4639C33 61.2416 36.5515 69.1819 42.2974 74.9278L46.3686 70.8566C41.691 66.1501 38.7748 59.6535 38.7748 52.4639C38.7748 45.2743 41.691 38.7777 46.3975 34.1001ZM57.5428 52.4639C57.5428 56.4485 60.7767 59.6824 64.7613 59.6824C68.7459 59.6824 71.9798 56.4485 71.9798 52.4639C71.9798 48.4793 68.7459 45.2454 64.7613 45.2454C60.7767 45.2454 57.5428 48.4793 57.5428 52.4639Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1714_3152",
    x: 0.151122,
    y: 0.151122,
    width: 126.52,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1714_3152"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1714_3152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1714_3152",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorsCase1);
export default __webpack_public_path__ + "static/media/CompetitorsCase1.efaf17e16b6e04536b3552f98991f58c.svg";
export { ForwardRef as ReactComponent };